import React from 'react';
import PropTypes from 'prop-types';
import ComponentsFactory from 'foundation/components-factory';

class StandaloneFactCard extends React.Component {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
    }

    componentDidMount() {
        ComponentsFactory.getInstance().init(this.rootRef.current);
    }

    componentWillUnmount() {
        ComponentsFactory.getInstance().destroy(this.rootRef.current);
    }

    render() {
        const { model, bemModifiers } = this.props;
        let bemCss = '';

        if (Array.isArray(bemModifiers)) {
            if (model.isDark) {
                bemModifiers.push('dark');
            }

            bemCss = bemModifiers.map((x) => `fact-card--${x}`).join(' ');
        }

        return (
            <span
                className={`standalone-fact-card fact-card ${bemCss}`}
                ref={this.rootRef}
            >
                <div className="fact-card__content">
                    <p className="standalone-fact-card__label fact-card__label">{model.label}</p>
                    <h3 className="standalone-fact-card__heading fact-card__heading">
                        <b>{model.title}</b>
                    </h3>
                </div>
                <div className="fact-card__bg">
                    <img className="lazyload" alt="" data-srcset={model.bgImage} data-sizes="auto" />
                </div>
            </span>
        );
    }
}

StandaloneFactCard.propTypes = {
    model: PropTypes.object.isRequired,
    bemModifiers: PropTypes.array,
};

export default StandaloneFactCard;
